import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Login from "./pages/Login";
import Shell from "./pages/Shell";
import Dashboard from "./pages/Dashboard";
import HeatMap from "./pages/HeatMap";
import Streams from "./pages/Streams";
import Employees from "./pages/Employees";
import Projects from "./pages/Projects";
import Revenue from "./pages/Revenue";
import LeaveDashboard from "./pages/LeaveDashboard";
import Upload from "./pages/Upload";
import History from "./pages/History";
import Users from "./pages/Users";
import Entitlements from "./pages/Entitlements";
import Settings from "./pages/Settings";

function Protected({ children, requireCap }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (requireCap && !(user.capabilities || []).includes(requireCap)) return <Navigate to="/dashboard" replace />;
  return children;
}

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginGate />} />
            <Route element={<Protected><Shell /></Protected>}>
              <Route path="/dashboard" element={<Protected requireCap="view_dashboard"><Dashboard /></Protected>} />
              <Route path="/heatmap" element={<Protected requireCap="view_heatmap"><HeatMap /></Protected>} />
              <Route path="/streams" element={<Protected requireCap="view_streams"><Streams /></Protected>} />
              <Route path="/employees" element={<Protected requireCap="view_employees"><Employees /></Protected>} />
              <Route path="/projects" element={<Protected requireCap="view_projects"><Projects /></Protected>} />
              <Route path="/revenue" element={<Protected requireCap="view_revenue"><Revenue /></Protected>} />
              <Route path="/leaves" element={<Protected requireCap="view_leaves"><LeaveDashboard /></Protected>} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/history" element={<Protected requireCap="view_history"><History /></Protected>} />
              <Route path="/users" element={<Protected requireCap="manage_users"><Users /></Protected>} />
              <Route path="/entitlements" element={<Protected requireCap="manage_entitlements"><Entitlements /></Protected>} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
